<div class="modal-header">
  <h4
    class="modal-title d-flex align-items-center"
    id="modal-title"
  >
    Domain Validation <span class="share-link ml-2">
    <a [href]="shareWidgetLinkUrl" target="_blank"><i class="fa fa-share"></i></a>
  </span>
  </h4>
  <div class="d-flex justify-content-end">
    <button
      type="button"
      aria-label="Close button"
      class="close"
      aria-describedby="modal-title"
      (click)="modal.dismiss('cancel')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <div>Add these config to your DNS settings in order to validate your domain. Detection of these records may take
        up to 72 hours
      </div>
      <ng-container *ngIf="!serviceProvider || serviceProvider !== 'mailchimp'">
        <div class="d-flex flex-column token-row" *ngFor="let token of tokens">
          <div class="token-row-item">
            <div class="token-item-label"><b>Type</b></div>
            <div class="token-item-value">CNAME</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Name</b></div>
            <div class="token-item-value">{{token}}._domainkey.{{getDomain(domain)}}</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Value</b></div>
            <div class="token-item-value">{{token}}.dkim.amazonses.com</div>
          </div>
        </div>

        <div class="d-flex flex-column token-row">
          <div class="token-row-item">
            <div class="token-item-label"><b>Type</b></div>
            <div class="token-item-value">MX</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Name</b></div>
            <div class="token-item-value">no-reply.{{getDomain(domain)}}</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Value</b></div>
            <div class="token-item-value">10 feedback-smtp.us-east-2.amazonses.com</div>
          </div>
        </div>

        <div class="d-flex flex-column token-row">
          <div class="token-row-item">
            <div class="token-item-label"><b>Type</b></div>
            <div class="token-item-value">TXT</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Name</b></div>
            <div class="token-item-value">no-reply.{{getDomain(domain)}}</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Value</b></div>
            <div class="token-item-value">"v=spf1 include:amazonses.com ~all"</div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="serviceProvider === 'mailchimp'">
        <div class="d-flex flex-column token-row">
          <div class="token-row-item">
            <div class="token-item-label"><b>Type</b></div>
            <div class="token-item-value">TXT</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Name</b></div>
            <div class="token-item-value">DKIM</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Value</b></div>
            <div class="token-item-value">{{tokens[0]}}</div>
          </div>
        </div>

        <div class="d-flex flex-column token-row">
          <div class="token-row-item">
            <div class="token-item-label"><b>Type</b></div>
            <div class="token-item-value">TXT</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Name</b></div>
            <div class="token-item-value">SPF</div>
          </div>

          <div class="token-row-item">
            <div class="token-item-label"><b>Value</b></div>
            <div class="token-item-value">{{tokens[1]}}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<input
  type="hidden"
  ngbAutofocus
>
<div class="modal-footer">
  <button
    class="btn btn-primary"
    type="button"
    (click)="close()"
  >
    Close
  </button>
</div>
